import * as React from 'react';
import { LinkIcon, QuestionMarkCircleIcon } from '@heroicons/react/20/solid';

import { useTrack } from '@blockworks/platform/services/analytics';
import { cn } from '@blockworks/ui/utils';

import addRefParam from '@/components/pages/grants/utils/add-ref-param';

export interface GrantsExternalLinkProps {
    href: string;
    text: string | JSX.Element | React.ReactNode;
    description?: string;
    className?: string;
    hideExternalLinkIcon?: boolean;
    onClick?: (ev: React.MouseEvent<HTMLAnchorElement>) => void;
}

const GrantsExternalLink = ({
    onClick,
    href,
    text,
    description,
    className,
    hideExternalLinkIcon,
}: GrantsExternalLinkProps) => {
    const track = useTrack();

    if (!href) {
        return null;
    }

    return (
        <a
            href={addRefParam(href)}
            className={cn('flex gap-1 items-center text-gray-300 relative', className)}
            target="_blank"
            rel="noreferrer"
            onClick={ev => {
                onClick && onClick(ev);
                track('Grants.ExternalLinkClicked', { href });
            }}
        >
            <span className="text-left text-brand-dark hover:text-brand truncate">
                <>{text}</>
            </span>
            {!hideExternalLinkIcon && <LinkIcon className="h-4 w-4" />}
            {description && (
                <span className="group hidden md:inline">
                    <QuestionMarkCircleIcon className="h-4 w-4 group-hover:text-brand-dark cursor-help" />
                    <div className="hidden group-hover:block absolute left-0 right-0 z-50 whitespace-normal">
                        <p className="text-gray-500 text-xs font-light px-3.5 pb-4 rounded rounded-t-none border border-t-0 border-gray-200 bg-gray-50 mt-[20pt] -ml-3.5 max-w-xl leading-4 text-justify tracking-wide">
                            {description}
                        </p>
                    </div>
                </span>
            )}
        </a>
    );
};

export default GrantsExternalLink;
